import { createAction } from 'redux-actions';
import types from './types';

export const saveShipping = createAction(types.SAVE_SHIPPING);
